import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-4 ml-6 text-md font-semibold text-gray-500" }
const _hoisted_2 = {
  key: 0,
  class: "px-4 grid grid-cols-2 xl:grid-cols-3"
}
const _hoisted_3 = { class: "grid xl:grid-cols-2 gap-4 col-span-2 h-max" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl group block w-32 h-8 bg-gray-50 rounded-md overflow-hidden my-2.5" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl group block w-full aspect-w-4 rounded-md aspect-h-3 bg-gray-50 overflow-hidden" }, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "col-span-2 grid grid-rows-3 content-start gap-4 xl:col-span-1 mt-4 ml-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl h-8 w-32 rounded-md block bg-gray-50 my-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "loadingEl h-1/2 rounded-md my-1 bg-gray-50" }, null, -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "grid gap-4"
}

import { useCurrentProject } from "@/composables/project";
import { useStreams } from "@/composables/stream";
import PlannerCard from "@/views/dashboard/components/PlannerCard";
import ProcessCard from "@/views/dashboard/components/ProcessCard.vue";
import StreamCard from "@/views/dashboard/components/StreamCard";
import StreamCardArchive from "@/views/dashboard/components/StreamCardArchive";
import WeatherCard from "@/views/dashboard/components/WeatherCard";
import NavigationComponent from "@/views/partials/NavigationComponent";
import LiveSwitch from "@/views/partials/components/LiveSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectOverview',
  setup(__props) {

const { streams, isLoading } = useStreams();
const currentProjectV2 = useCurrentProject();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NavigationComponent), {
      activeTag: _ctx.$t('app_features.project_overview')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(currentProjectV2).name), 1),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                  return _createElementVNode("div", {
                    class: "col-span-1 mt-4 shadow bg-white py-2 px-4",
                    key: i
                  }, _hoisted_6)
                }), 64))
              ]),
              (_unref(currentProjectV2).status === 'active')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                      return _createElementVNode("div", {
                        class: "shadow bg-white p-4",
                        key: i
                      }, _hoisted_10)
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(['px-4 grid mb-10', _unref(streams).length === 1 ? 'xl:grid-cols-5' : 'xl:grid-cols-3'])
              }, [
                (_unref(streams).length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass([_unref(streams).length === 1 ? 'xl:col-span-3' : 'xl:col-span-2'])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
              'grid grid-cols-1 gap-4 mt-4',
              { 'lg:grid-cols-2 w-full': _unref(streams).length > 1 },
            ])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(streams), (stream) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: stream._id
                          }, [
                            (_unref(currentProjectV2).status === 'active' && stream.aws_stream_id)
                              ? (_openBlock(), _createBlock(_unref(StreamCard), {
                                  key: 0,
                                  stream: stream
                                }, null, 8, ["stream"]))
                              : (_openBlock(), _createBlock(_unref(StreamCardArchive), {
                                  key: 1,
                                  stream: stream
                                }, null, 8, ["stream"]))
                          ], 64))
                        }), 128))
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass([
            'xl:pl-4 mt-4 h-full col-span-1',
            _unref(streams).length <= 1 ? 'xl:col-span-2' : 'xl:col-span-1',
          ])
                }, [
                  (_unref(currentProjectV2).status === 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_unref(WeatherCard), { ref: "weatherCardComponent" }, null, 512),
                        (_ctx.hasPermission('processes_user'))
                          ? (_openBlock(), _createBlock(ProcessCard, { key: 0 }))
                          : _createCommentVNode("", true),
                        (_ctx.hasPermission('planner_user'))
                          ? (_openBlock(), _createBlock(_unref(PlannerCard), { key: 1 }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2)
            ]))
      ]),
      _: 1
    }, 8, ["activeTag"]),
    _createVNode(LiveSwitch)
  ], 64))
}
}

})